module.exports = __webpack_public_path__ + "h5/img/noCollection.01b8125d.png";